exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slick-slider[data-v-4c5131a9] .video__wrap .video__element{-o-object-fit:contain;object-fit:contain}", ""]);

// exports
